import { render } from "./InfoMenu.vue?vue&type=template&id=1b5acec3&scoped=true"
import script from "./InfoMenu.vue?vue&type=script&lang=js"
export * from "./InfoMenu.vue?vue&type=script&lang=js"

import "./InfoMenu.vue?vue&type=style&index=0&id=1b5acec3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5acec3"]])

export default __exports__